import moment from 'moment';
import queryString from 'qs';

const getExportReportOperatorRequest = (filter) =>
  queryString.stringify({
    ...(filter?.search && { search: filter.search }),
    ...(filter?.monthYear && { monthYear: moment(filter.monthYear).format('MM-YYYY') }),
  });

export default getExportReportOperatorRequest;
